import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const AFFILIATE_KEY = "gaonova_affiliate_code";
const AFFILIATE_EXPIRY_DAYS = 30;

export const useAffiliateTracking = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const affCode = searchParams.get("aff");
    if (affCode) {
      const data = {
        code: affCode,
        expires: Date.now() + AFFILIATE_EXPIRY_DAYS * 24 * 60 * 60 * 1000,
      };
      localStorage.setItem(AFFILIATE_KEY, JSON.stringify(data));
      console.log(`[Affiliate] Tracked: ${affCode}`);
    }
  }, [searchParams]);

  const getActiveAffiliateCode = (): string | null => {
    const stored = localStorage.getItem(AFFILIATE_KEY);
    if (!stored) return null;

    try {
      const data = JSON.parse(stored);
      if (Date.now() > data.expires) {
        localStorage.removeItem(AFFILIATE_KEY);
        return null;
      }
      return data.code;
    } catch {
      return null;
    }
  };

  const clearAffiliateCode = () => {
    localStorage.removeItem(AFFILIATE_KEY);
  };

  return { getActiveAffiliateCode, clearAffiliateCode };
};
